import cssGenerator from '../../css-generator';

const { BREAKPOINT_ORDER } = cssGenerator.constants;

function sortResponsiveValues(values) {
  return values.slice().sort((a, b) => {
    const getBp = (val) => {
      const index = val.indexOf(':');
      return index === -1 ? '' : val.slice(0, index);
    };
    return BREAKPOINT_ORDER.indexOf(getBp(a)) - BREAKPOINT_ORDER.indexOf(getBp(b));
  });
}

const createResponsiveValue = (newValue, value, breakpoint) => {
  const prefixedValue = breakpoint ? `${breakpoint}:${newValue}` : newValue;
  const regExp = new RegExp(`\\b${breakpoint}:[^\\s]+\\b`, 'g');

  const filteredValue = value.split(' ').filter((val) => {
    if (!val) return false;

    if (breakpoint) {
      return !regExp.test(val);
    }

    return val.includes(':');
  });

  filteredValue.push(prefixedValue);

  return sortResponsiveValues(filteredValue).join(' ');
};

export default createResponsiveValue;
